<template>
  <BaseSimpleModal
    :width="isMobile ? '100%' : '512px'"
    @close="closeModal"
  >
    <template #body>
      <div class="transfer-notify">
        <h1>Você tem Pratas disponíveis para transferir para a Livelo!</h1>

        <p>
          Você tem mais de <em>1.000 Pratas</em>, e já pode transferir seu saldo livremente para a
          <em>Livelo</em> e aproveitar recompensas incríveis.
        </p>
        <p><em>Transfira agora e não deixe seus pontos expirarem.</em></p>
      </div>
    </template>
    <template #actions>
      <label class="checkbox">
        <input
          v-model="shouldStopShowing"
          type="checkbox"
        >
        Não desejo ver esse aviso novamente.
      </label>

      <div class="buttons ml-auto">
        <button
          class="button"
          @click="closeModal"
        >
          Fechar
        </button>
        <button
          class="button is-success"
          @click="goToLandingPage"
        >
          Ver minhas pratas
        </button>
      </div>
    </template>
  </BaseSimpleModal>
</template>
<script>
import { mapGetters } from 'vuex';

import BaseSimpleModal from '@/components/BaseSimpleModal.vue';

export default {
  name: 'TransferNotifyLiveloModal',
  components: {
    BaseSimpleModal,
  },
  data() {
    return {
      shouldStopShowing: false,
    };
  },
  computed: {
    ...mapGetters({
      isMobile: 'app/isMobile',
    }),
  },
  methods: {
    goToLandingPage() {
      const { href } = this.$router.resolve({ name: 'livelo-statement' });
      window.open(href, '_blank');
    },
    closeModal() {
      if (this.shouldStopShowing) {
        localStorage.setItem('shouldStopShowingTransferLiveloModal', this.shouldStopShowing);
      }
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
$livelo-transfer-banner: '../assets/image/transfer-notify.png';
$livelo-transfer-banner-mobile: '../assets/image/transfer-notify-mobile.png';

.transfer-notify {
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url($livelo-transfer-banner);

  padding: 32px;
  width: 100%;
  height: 483px;
  border-radius: 8px;

  h1, p {
    color: #FFF;
  }

  h1 {
    font-weight: 800;
    font-size: 20px;
    line-height: 36px;
  }

  p {
    margin-top: 4px;
    max-width: 80%;
    font-size: 14px;
    line-height: 24px;

    em {
      font-style: normal  ;
      font-weight: 700;
    }
  }
}

@media only screen and (max-width: 576px) {
  .transfer-notify {
    background-image: url($livelo-transfer-banner-mobile);
    p {
      max-width: 100%;
    }
  }
}

</style>
